import React from 'react';
import I18n from 'i18n-js';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import URLHelpers from '../../shared/url_helpers';
import DashboardPageHeader from '../../dashboard_page_header';

interface IShipOrderHeaderProps {
  pageTitle: string;
  subtitle?: string | React.ReactNode;
  orderId: string;
  shippingDetailsPath?: string;
  step?: number;
}

export default function ShipOrderHeader({ pageTitle, subtitle = null, orderId, step = null, shippingDetailsPath = null }: IShipOrderHeaderProps) {

  const StepCounter = () => {
    if (!step) return null;

    return (
      <span className="ship-order-header__step-counter">
        {I18n.t('discovery.dashboard.selling.shipOrderViews.header.step', { step })}
      </span>
    );
  };

  const breadcrumbs = [
    {
      title: I18n.t('discovery.dashboard.selling.shipOrderViews.header.selling'),
      to: URLHelpers.listingsManagerPath(),
    },
    {
      title: I18n.t('discovery.dashboard.selling.shipOrderViews.header.allOrders'),
      to: URLHelpers.ordersManagerPath(),
    },
    {
      title: I18n.t('discovery.dashboard.selling.shipOrderViews.header.orderNumber', { orderId }),
      to: URLHelpers.orderPath({ orderId }),
      current: !shippingDetailsPath,
    },
  ];

  if (shippingDetailsPath) {
    breadcrumbs.push({
      title: I18n.t('discovery.dashboard.selling.shipOrderViews.header.shippingDetails'),
      to: shippingDetailsPath,
      current: true,
    });
  }

  return (
    <div className="ship-order-header">
      <DashboardPageHeader
        breadcrumbs={breadcrumbs}
        title={
          <>
            {pageTitle}&nbsp;
            <StepCounter />
          </>
        }
        subtitle={ subtitle ||
          <SanitizedRender
            html={
              I18n.t(
                'discovery.dashboard.selling.shipOrderViews.header.visitShippingGuide',
                { linkOpen: `<a class="text-link" href=${URLHelpers.shippingGuidePath}>`, linkClose: '</a>' },
              )
            }
          />
        }
      />
    </div>
  );
}
